if (!customElements.get('swiper-image-with-link')) {
    customElements.define(
        'swiper-image-with-link',
        class SwiperImageWithLink extends HTMLElement {
            constructor() {
                super();
                this.swiperInstance = null;
                this.swiperEl = this.querySelector('.swiper');
                this.pcAddButton = this.querySelector('.single-add-to-cart-button.swiper-image-with-link__button');
                this.mobileAddButton = this.querySelector('.swiper-image-with-link__button-mb');
            }

            connectedCallback() {
                const pagination = this.querySelector('.swiper-pagination');
                const prevButton = this.querySelector('.swiper-button-prev');
                const nextButton = this.querySelector('.swiper-button-next');
                this.swiperInstance = new Swiper(this.swiperEl, {
                    slidesPerView: 1.55,
                    spaceBetween: 30,
                    // pagination: {
                    //     el: pagination,
                    //     clickable: true,
                    // },
                    loop: true,
                    navigation: {
                        nextEl: nextButton,
                        prevEl: prevButton,
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1.1,
                            spaceBetween: 15,
                        },
                        1001: {
                            slidesPerView: 1.55,
                            spaceBetween: 30,
                        },
                    }
                });


                if (this.pcAddButton && this.mobileAddButton) {
                    this.mobileAddButton.addEventListener('click', () => {
                        this.mobileAddButtonFunction();
                    });
                }
            }

            mobileAddButtonFunction() {
                this.pcAddButton.click();
                this.mobileAddButton.classList.add('loading');

                // 创建观察器监听 body 的 class 变化
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach(mutation => {
                        if (mutation.attributeName === 'class') {
                            if (document.body.classList.contains('open-cart')) {
                                this.mobileAddButton.classList.remove('loading');
                                observer.disconnect(); // 任务完成后断开观察
                            }
                        }
                    });
                });

                // 开始观察 body 的 class 属性
                observer.observe(document.body, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            }

            disconnectedCallback() {
            }
        }
    );
}
